<template>
  <div>
    <RuTermsOfUse v-if="locale === 'ru'" />
    <CsTermsOfUse v-else-if="locale === 'cs'" />
    <DeTermsOfUse v-else-if="locale === 'de'" />
    <EsTermsOfUse v-else-if="locale === 'es'" />
    <FrTermsOfUse v-else-if="locale === 'fr'" />
    <HuTermsOfUse v-else-if="locale === 'hu'" />
    <ItTermsOfUse v-else-if="locale === 'it'" />
    <JaTermsOfUse v-else-if="locale === 'ja'" />
    <NlTermsOfUse v-else-if="locale === 'nl'" />
    <PlTermsOfUse v-else-if="locale === 'pl'" />
    <PtTermsOfUse v-else-if="locale === 'pt'" />
    <SvTermsOfUse v-else-if="locale === 'sv'" />
    <TrTermsOfUse v-else-if="locale === 'tr'" />
    <UkTermsOfUse v-else-if="locale === 'uk'" />
    <ArTermsOfUse v-else-if="locale === 'ar'" />
    <CnTermsOfUse v-else-if="locale === 'cn' || locale === 'zh'" />
    <KoTermsOfUse v-else-if="locale === 'ko'" />
    <EnTermsOfUse v-else />
  </div>
</template>

<script>
import RuTermsOfUse from '@/components/policy/locales/ru/RuTermsOfUse.vue'
import EnTermsOfUse from '@/components/policy/locales/en/EnTermsOfUse.vue'
import CsTermsOfUse from '@/components/policy/locales/cs/CsTermsOfUse.vue'
import DeTermsOfUse from '@/components/policy/locales/de/DeTermsOfUse.vue'
import EsTermsOfUse from '@/components/policy/locales/es/EsTermsOfUse.vue'
import FrTermsOfUse from '@/components/policy/locales/fr/FrTermsOfUse.vue'
import HuTermsOfUse from '@/components/policy/locales/hu/HuTermsOfUse.vue'
import ItTermsOfUse from '@/components/policy/locales/it/ItTermsOfUse.vue'
import JaTermsOfUse from '@/components/policy/locales/ja/JaTermsOfUse.vue'
import NlTermsOfUse from '@/components/policy/locales/nl/NlTermsOfUse.vue'
import PlTermsOfUse from '@/components/policy/locales/pl/PlTermsOfUse.vue'
import PtTermsOfUse from '@/components/policy/locales/pt/PtTermsOfUse.vue'
import SvTermsOfUse from '@/components/policy/locales/sv/SvTermsOfUse.vue'
import TrTermsOfUse from '@/components/policy/locales/tr/TrTermsOfUse.vue'
import UkTermsOfUse from '@/components/policy/locales/uk/UkTermsOfUse.vue'
import ArTermsOfUse from '@/components/policy/locales/ar/ArTermsOfUse.vue'
import CnTermsOfUse from '@/components/policy/locales/cn/CnTermsOfUse.vue'
import KoTermsOfUse from '@/components/policy/locales/ko/KoTermsOfUse.vue'
export default {
  name: 'TermsOfUse',
  components: {
    EnTermsOfUse,
    RuTermsOfUse,
    CsTermsOfUse,
    DeTermsOfUse,
    CnTermsOfUse,
    UkTermsOfUse,
    TrTermsOfUse,
    SvTermsOfUse,
    PtTermsOfUse,
    PlTermsOfUse,
    NlTermsOfUse,
    JaTermsOfUse,
    ItTermsOfUse,
    HuTermsOfUse,
    FrTermsOfUse,
    EsTermsOfUse,
    ArTermsOfUse,
    KoTermsOfUse,
  },
  props: {
    locale: {
      type: String,
      required: true,
    },
  }
}
</script>

<style scoped>

</style>
